import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudService, CrudType, IApplicationResponse,  ModulesBasedApiSuffix, onActionSubmittedUtil, prepareGetRequestHttpParams, RxjsService, UserService } from '@app/shared';
import { DealerExecuteDialogComponent } from '@modules/dealer';
import { DealerModuleApiSuffixModels } from '@modules/dealer/shared/enum/dealer.enum';
import { Store, select } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { PrimeNgTableVariablesModel } from '../../../../shared/models/prime-ng-table-list-component-variables.model';
import { handleNgrxStoreData, processStoreData } from '@app/shared/utils/combine-page-level.utils';
import { loggedInUserData } from '@modules/others';
import { UserLogin } from '@modules/others/models';

@Component({
  selector: 'app-dealer-stock-scheduling',
  templateUrl: './dealer-stock-scheduling.component.html'
})
export class DealerStockSchedulingComponent extends PrimeNgTableVariablesModel implements OnInit {

  primengTableConfigProperties: any;
  row: any = {};
  listSubscription: any;
  first: any = 0;
  filterData: any;
  seletedItemsIds: any = [];

  constructor(
    private crudService: CrudService,
    private dialogService: DialogService,
    private rxjsService: RxjsService,
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute, 
    private userService: UserService) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Dealer Stock Scheduling",
      breadCrumbItems: [{ displayName: 'Inventory Management', relativeRouterUrl: '' }, { displayName: 'Dealer Stock Table Selling Price', relativeRouterUrl: '/dealer/dealer-stock-selling-price' }, { displayName: 'Dealer Stock Scheduling' },
      { displayName: 'Schedule Selling Price' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Schedule Selling Price',
            dataKey: 'dealerItemSellingPriceId',
            captionFontSize: '21px',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            checkBox: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'dealeritemSellingPriceCode', header: 'Selling Price ID', width: '130px' },
              { field: 'itemCode', header: 'Stock Code', width: '110px' },
              { field: 'sellingPrice', header: 'Selling Price', width: '120px', isDecimalFormat: true },
              { field: 'costPrice', header: 'Cost Price', width: '90px', isDecimalFormat: true },
              { field: 'labourRate', header: 'Labour Rate', width: '110px', isDecimalFormat: true },
              { field: 'materialMarkup', header: 'Material Markup', width: '130px' },
              { field: 'consumableMarkup', header: 'Consumable Markup', width: '160px' },
            ],
            enableReloadBtn: true,
            isDateWithTimeRequired: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER_STOCK_SCHEDULE_SELLING_PRICE,
            moduleName: ModulesBasedApiSuffix.INVENTORY,
          },
          {
            caption: 'Scheduled Jobs',
            dataKey: 'dealerSellingPriceJobId',
            captionFontSize: '21px',
            enableBreadCrumb: true,
            enableScrollable: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'dealerSellingPriceJobCode', header: 'Job ID', width: '100px' },
              { field: 'executionDate', header: 'Execution Date', width: '70px', isDateTime:true  },
              { field: 'userName', header: 'Scheduled By', width: '100px' },
              { field: 'createdDate', header: 'Created Date', width: '100px', isDateTime:true  }
            ],
            isDateWithTimeRequired: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER_STOCK_SELLING_PRICE_JOB,
            moduleName: ModulesBasedApiSuffix.INVENTORY,
          },
          {
            caption: 'Archive',
            dataKey: 'dealerSellingPriceJobId',
            captionFontSize: '21px',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'dealerSellingPriceJobCode', header: 'Job ID', width: '100px' },
              { field: 'executionDate', header: 'Execution Date', width: '70px' , isDateTime:true },
              { field: 'userName', header: 'Scheduled By', width: '100px' },
              { field: 'createdDate', header: 'Created Date', width: '100px', isDateTime:true  }
            ],
            isDateWithTimeRequired: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER_STOCK_SELLING_PRICE_JOB,
            moduleName: ModulesBasedApiSuffix.INVENTORY,
          }
        ]
      }
    }
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.loggedInUserData = userData;
    });
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.selectedTabIndex = (Object.keys(params['params']).length > 0) ? +params['params']['tab'] : 0;
      this.primengTableConfigProperties.selectedTabIndex = this.selectedTabIndex;
      this.primengTableConfigProperties.breadCrumbItems[3].displayName = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].caption;
    });
  }

  ngOnInit(): void {
    // handleNgrxStoreData((response) => {
    //   let processData = processStoreData(response, this.primengTableConfigProperties, null);
    //   this.primengTableConfigProperties = processData.primengTableConfigProperties
    //   this.loggedInUserData = processData.loggedInUserData
    // }, this.store);
    this.onCRUDRequested('get');
  }


  tabClick(e) {
    this.selectedTabIndex = e?.index;
    this.dataList = [];
    this.onCRUDRequested('get');
    this.router.navigate([`../`], { relativeTo: this.activatedRoute, queryParams: { tab: this.selectedTabIndex } });
  }

  getTableListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    let dealerModuleApiSuffixModels: DealerModuleApiSuffixModels;
    dealerModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    if (this.listSubscription && !this.listSubscription.closed) {
      this.listSubscription.unsubscribe();
      this.rxjsService.setGlobalLoaderProperty(false);
    }
    this.listSubscription = this.crudService.get(
      this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
      dealerModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe((data: IApplicationResponse) => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess) {
        this.dataList = data.resources;
        this.totalRecords = data.totalCount;
      } else {
        this.dataList = null;
        this.totalRecords = 0;
      }
    })
  }

  onCRUDRequested(type: CrudType | string, row?: object | any, unknownVar?: any): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.row = row ? row : { pageIndex: 0, pageSize: 10 };
        this.first = row?.pageIndex && row?.pageSize ? row["pageIndex"] * row["pageSize"] : 0;
        switch (this.selectedTabIndex) {
          case 0:
            unknownVar = { IsAll: true, ...unknownVar };
            break;
          case 1:
            unknownVar = { IsArchive: false, ...unknownVar };
            break;
          case 2:
            unknownVar = { IsArchive: true, ...unknownVar };
            break;
          default:
            break;
        }
        unknownVar = { ...this.filterData, ...unknownVar };
        this.getTableListData(this.row["pageIndex"], this.row["pageSize"], unknownVar);
        break;
      case CrudType.EDIT:
        this.openAddEditPage(CrudType.EDIT, row);
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      case CrudType.RELOAD:
        this.onCRUDRequested('get');
        break;
      default:
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string, index?: number): void {
    switch (type) {
      case CrudType.VIEW:
        if (this.selectedTabIndex == 1) {
          this.router.navigate(['./view'], { relativeTo: this.activatedRoute, queryParams: { id: editableObject[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey], archive: false } })
        }
        switch (this.selectedTabIndex) {
          case 1:
            this.router.navigate(['./view'], { relativeTo: this.activatedRoute, queryParams: { id: editableObject[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey], archive: false } })
            break;
          case 2:
            this.router.navigate(['./view'], { relativeTo: this.activatedRoute, queryParams: { id: editableObject[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey], archive: true } })
            break;
          default:
            break;
        }
        break;
      case CrudType.EDIT:
        break;
    }
  }


  onChangeSelecedRows(e) {
    this.selectedRows = e;
    var seletedIds = [];
    this.selectedRows.forEach((element: any) => {
      seletedIds.push(element[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey])
    });
    this.seletedItemsIds = seletedIds;
  }

  proceed() {
    const data = {
      row: {
        dealerItemSellingPriceId: this.seletedItemsIds.toString(),
        executionDate: null,
        createdUserId: this.loggedInUserData.userId,
      },
      api: DealerModuleApiSuffixModels.DEALER_STOCK_SELLING_PRICE_JOB,
      module: ModulesBasedApiSuffix.INVENTORY,
    };
    this.onOpenExecuteDialog('Execute', data);
  }

  proceedAll() {
    const data = {
      row: {
        dealerItemSellingPriceId: null,
        executionDate: null,
        createdUserId: this.loggedInUserData.userId,
      },
      api: DealerModuleApiSuffixModels.DEALER_STOCK_SELLING_PRICE_JOB,
      module: ModulesBasedApiSuffix.INVENTORY,
    };
    this.onOpenExecuteDialog('Execute All', data);
  }

  onOpenExecuteDialog(header, data) {
    const ref = this.dialogService.open(DealerExecuteDialogComponent, {
      header: header,
      showHeader: false,
      baseZIndex: 1000,
      width: '400px',
      data: data
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result: IApplicationResponse) => {
      if (result?.isSuccess && result?.statusCode == 200) {
        this.selectedRows = [];
        this.getTableListData();
      }
      this.userService.openedPrimeDialog = [];
    });
  }

  cancel() {
    this.router.navigate(['/dealer/dealer-stock-selling-price']);
  }
  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }
  ngOnDestroy() {
    if (this.listSubscription) {
      this.listSubscription.unsubscribe();
    }
  }
}
